module.exports = __webpack_public_path__ + "img/codigo-barras.c25e1e65.svg";